<template>
  <Popup :width="width" :closePopupEvent="closePopupCB">
    <div slot="header">
      <h6
        class="login-header"
      >{{ showLoginForm ? "Already Have An Account" : emailPopup ? "Please Enter Your Email ID" : "Confirm Your 18+" }}</h6>
    </div>
    <div class="session-exp-popup">
      <div v-if="showLoginForm">
        <div class="login-logo">
          <img src="@/assets/icons/Logo_sdg1.svg" alt="logo" />
        </div>

        <div style="margin-left: 10%">
          <p class="login-with">Sign In With</p>
        </div>
        <div class="social-logo">
          <div class="social-google">
            <div id="googlelogin" style="height: 100%;margin-right:10px;">
              <img src="@/assets/icons/icons8-google.svg" alt="google logo" />
              <p>Google</p>
            </div>
          </div>
          <div class="social-fb">
            <div style="height:100%;" id="facebooklogin" @click="signupFacebookCB">
              <img src="@/assets/icons/fb-ico-white.svg" alt="facebook logo" />
              <p>Facebook</p>
            </div>
          </div>
        </div>
        <div class="vlt-signup-divd row">
          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xlg-5 orline"></div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xlg-2">
            <p class="or">or</p>
          </div>
          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xlg-5 orline"></div>
        </div>
        <!-- Form -->
        <div class="login-form">
          <form @submit.prevent="loginUserCB" autocomplete="off">
            <input autocomplete="false" name="hidden" type="text" style="display:none;" />

            <div class="vlt-lgn-form">
              <!-- Email Input -->
              <div class="vlt-input-group">
                <label class="login-label">Email</label>
                <input
                  id="userEmail"
                  type="email"
                  aria-label="email"
                  v-model="userEmail"
                  placeholder
                  ref="userEmail"
                  maxlength="128"
                  tabindex="1"
                />
                <p class="login-error-message">{{ userEmailError }}</p>
              </div>

              <!-- Password Input -->
              <div class="vlt-input-group input-ico">
                <label class="login-label">Password</label>
                <div class="vlt-input">
                  <input
                    id="password"
                    type="password"
                    aria-label="password"
                    v-model="password"
                    placeholder
                    autocomplete="off"
                    maxlength="16"
                    tabindex="2"
                  />
                  <p class="login-error-message">{{ passwordError }}</p>
                  <span class="ico-img" style="cursor:pointer;">
                    <img :src="iconEyeOpenPath" @click="toggleInputMode" alt="eye img" />
                  </span>
                </div>
              </div>

              <!-- Forgot Password -->
              <p
                class="vlt-link vlt-lgn-fgtpwd"
                @click="() => showResetPasswordPopup(true)"
              >Forgot Password?</p>

              <!-- Buttons -->
              <div class="vlt-lgn-btns">
                <button
                  type="submit"
                  class="btn-lg-primary"
                  ref="loginBtnSubmit"
                  aria-label="Sign In"
                >Sign In</button>
              </div>
            </div>
          </form>
        </div>
        <Loading v-show="showLoading"></Loading>
        <div class="vlt-signup">
          <p class="new-user">Don't have an Account?</p>
          <button
            @click="openSignUpPopup"
            class="signup"
            ref="signupBtn"
            aria-label="Sign Up"
          >Sign up</button>
        </div>
      </div>
      <div v-if="!showLoginForm" class="check-container">
        <div v-if="emailPopup">
          <p>We are unable to get your Email ID, Please enter your Email ID to proceed.</p>
          <div class="vlt-lgn-btns">
            <!-- Email Input -->
            <div class="vlt-input-group">
              <label class="login-label">Email ID</label>
              <input
                id="userEmail"
                type="email"
                aria-label="email"
                v-model="userEmail"
                placeholder
                ref="fbUserEmail"
                maxlength="128"
                tabindex="1"
              />
              <p class="login-error-message">{{ userEmailError }}</p>
            </div>
            <div class="movie-filter" style="margin-top:15px;">
              <label class="checkboxcontainer agecheck" for="ageCheck">
                I'm 18+
                <input
                  type="checkbox"
                  name="checkbox"
                  v-model="ageCheck"
                  value="1"
                  id="ageCheck"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <button
              type="button"
              class="btn-lg-primary"
              ref="loginBtnSubmit"
              @click="proceedClick"
              aria-label="Yes"
            >Proceed</button>
          </div>
        </div>
        <div v-else>
          <p>You must be 18+ to Create an SDG Account</p>
          <button
            type="button"
            class="btn-lg-primary"
            ref="loginBtnSubmit"
            @click="check18plus(1)"
            aria-label="Yes"
            style="margin-bottom:10px"
          >yes, i'm 18+</button>
          <button
            type="button"
            class="btn-lg-primary no"
            ref="loginBtnSubmit"
            @click="check18plus(0)"
            aria-label="No"
          >no, i'm not</button>
        </div>
      </div>
      <FormError v-show="formError" :message="formError"></FormError>
    </div>
  </Popup>
</template>

<script>
import Content from "@/mixins/Content";
import Utility from "@/mixins/Utility";
import GoogleAnalytics from "@/mixins/GoogleAnalytics";
import { EventBus } from "@/main";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "LoginForm",
  data() {
    return {
      width: "30%",
      userEmail: undefined,
      password: undefined,
      iconEyeOpenPath: require("@/assets/icons/Eye_open.svg"),
      iconEyeClosePath: require("@/assets/icons/Eye_closed.svg"),
      showLoading: false,
      formError: null,
      //
      userEmailError: "",
      passwordError: "",
      //
      showLoginForm: true,
      social: {},
      mode: null,
      ageCheck: false,
      emailPopup: false
    };
  },
  props: ["closePopupCB", "previousActionData"],
  components: {
    Popup: () => import("@/components/Slots/Popup.vue"),
    Loading: () => import("@/components/Templates/Loading.vue"),
    FormError: () => import("@/components/Templates/FormError.vue")
  },
  created() {
    EventBus.$on("getFBEmail", () => {
      this.emailPopup = true;
      this.userEmail = null;
      this.width = "35%";
      this.showLoginForm = false;
    });
    // signupError
    EventBus.$on("loginError", error => {
      let GA = {
        "Event Label": "Failure",
        Status: "FAILURE",
        ErrorCode: error.Code,
        ErrorMessage: error.Message
      };
      this.loginEvent(GA);
      if (this.mode) {
        let GA = {
          "Event Label": "Failure",
          Status: "FAILURE",
          ErrorCode: error.Code,
          ErrorMessage: error.Message,
          Mode: this.mode
        };
        this.signUpEvent(GA);
      }
      console.log("loginError", error);
      //
      this.formError = error.Message;
      this.$refs.loginBtnSubmit.disabled = false;
      this.$refs.signupBtn.disabled = false;
      this.showLoading = false;
      // To re-enable:
      document.getElementById("googlelogin").style.pointerEvents = "auto";
    });
    //signupSuccess
    EventBus.$on("loginSuccess", () => {
      let GA = {
        "Event Label": "Success",
        Status: "SUCCESS"
      };
      this.loginEvent(GA);
      if (this.mode) {
        let GA = {
          "Event Label": "Success",
          Status: "SUCCESS",
          Mode: this.mode
        };
        this.signUpEvent(GA);
      }
      //
      // console.log("loginSuccess-previousActionData", this.previousActionData);
      if (this.previousActionData) {
        if (
          this.previousActionData.button &&
          this.previousActionData.button === "LIKEDISLIKE"
        ) {
          this.updateLikeDislikeToFire(
            this.previousActionData.content,
            this.previousActionData.action
          );
        } else {
          switch (this.previousActionData.popup) {
            case "PaymentPopup":
              this.actListTicket().then(response => {
                let showPaymentPopup = true;
                if (response.length > 0) {
                  let index = response.findIndex(
                    ele => ele.contentid === this.previousActionData.contentid
                  );
                  if (index > -1) {
                    showPaymentPopup = false;
                  }
                }
                if (showPaymentPopup) {
                  let data = {
                    contentid: this.previousActionData.contentid
                  };
                  if (this.previousActionData.coupon) {
                    data.coupon = this.previousActionData.coupon;
                  }
                  EventBus.$emit("PaymentPopup", data);
                }
              });
              break;
            case "sharedPopup":
              if (
                this.previousActionData.action &&
                this.previousActionData.content
              ) {
                this.updateLikeDislikeToFire(
                  this.previousActionData.content,
                  this.previousActionData.action
                );
              }
              EventBus.$emit(
                "sharedPopup",
                this.previousActionData.content
                  ? this.previousActionData.content.contentid
                  : this.previousActionData.contentid
              );
              break;
            case "ContactPopup":
              EventBus.$emit("ContactPopup");
          }
        }
      }
      // Hide the popup
      this.closePopupCB();
    });
  },
  watch: {
    formError(value) {
      if (value) {
        setTimeout(() => {
          this.formError = null;
        }, 5000);
      }
    },
    userEmail() {
      if (this.userEmailError) {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
      }
    },
    password() {
      if (this.passwordError) {
        this.passwordError = "";
        document.getElementById("password").classList.remove("formError");
      }
    }
  },
  beforeDestroy() {
    // Stop listening
    EventBus.$off("loginSuccess");
    EventBus.$off("loginError");
  },
  mounted() {
    this.initGoogleSignupAPI();
  },
  methods: {
    ...mapActions(["actListTicket", "actGetSubscriber"]),
    check18plus(status) {
      this.width = "30%";
      if (status) {
        this.showLoading = true;
        if (!this.checkCookie()) {
          EventBus.$emit("loginUser", this.social, "L");
        } else {
          window.location.reload();
        }
      } else {
        this.showLoading = false;
        this.social = null;
        this.mode = null;
        this.emailPopup = false;
      }
      this.showLoginForm = true;
      setTimeout(() => {
        this.initGoogleSignupAPI();
      }, 100);
    },
    proceedClick() {
      let showLogin = false;
      if (this.validateEmailInput()) {
        if (this.ageCheck) {
          this.showLoading = true;
          if (!this.checkCookie()) {
            showLogin = true;
            this.social.email = this.userEmail;
            EventBus.$emit("loginUser", this.social, "L");
          } else {
            window.location.reload();
          }
        } else {
          this.formError = "Please confirm your 18+";
        }
      }
      if (showLogin) {
        this.width = "30%";
        this.showLoginForm = true;
        setTimeout(() => {
          this.initGoogleSignupAPI();
          this.userEmail = null;
          this.emailPopup = false;
        }, 100);
      }
    },
    initGoogleSignupAPI() {
      gapi.load("auth2", () => {
        let auth2 = gapi.auth2.init({
          client_id:
            "42494403169-nl3r32rr52d6bsrgvckmqe5vs4hp5o8n.apps.googleusercontent.com",
          cookiepolicy: "single_host_origin",
          scope: "profile"
        });

        auth2.attachClickHandler(
          document.getElementById("googlelogin"),
          {},
          user => {
            var profile = user.getBasicProfile();
            if (profile.getId()) {
              let token = user.getAuthResponse().id_token;
              this.social = {
                app: "GOOGLE",
                token: token
              };
              this.mode = "GOOGLE";
              this.showLoader();
              this.actGetSubscriber({ email: profile.getEmail() })
                .then(response => {
                  this.showLoader = false;
                  if (response.error) {
                    this.emailPopup = false;
                    this.width = "25%";
                    this.showLoginForm = false;
                    //
                    this.mode = "GOOGLE";
                  } else {
                    this.showLoading = true;
                    if (!this.checkCookie()) {
                      EventBus.$emit("loginUser", this.social, "L");
                    } else {
                      window.location.reload();
                    }
                  }
                })
                .catch(error => {
                  this.emailPopup = false;
                  this.width = "25%";
                  this.showLoginForm = false;
                  //
                  this.mode = "GOOGLE";
                });

              //
              // EventBus.$emit('loginUser',this.social,'L');
            }
          },
          error => {}
        );
      });
    },
    signupFacebookCB() {
      if (this.showLoading) return;
      let self = this;
      // Get the login status
      // FB.getLoginStatus(response => {
      //   console.log('getLoginStatus',response);
      FB.login(
        function(response) {
          // console.log("fbrsponse", response);
          if (response.authResponse) {
            console.log('auth token', response.authResponse);
            // let GA = {
            //   "Event Label": "Success",
            //   Status: "SUCCESS"
            // };
            // self.facebookLoginEvent(GA);
            //
            let token = response.authResponse.accessToken;
            let userId = response.authResponse.userID;

            self.social = {
              app: "FB",
              token: token
            };
            // self.mode = "FACEBOOK";
            // self.showLoading = true;
            // EventBus.$emit("loginUser", self.social, "L");
            FB.api("/me" , { fields: "id,name,email" },
              function(response) {
                if (response) {
                  let res = response;
                  console.log('response result', res);
                  let email = res.email
                  let param = {
                    email: email
                  }
                  console.log('params', param);
                  self.actGetSubscriber(param)
                    .then(response => {
                      console.log('get subscriber response', response);
                      if (response.error) {
                        self.width = "25%";
                        self.showLoginForm = false;
                        //
                        self.mode = "FACEBOOK";
                      } else {
                        if (response.email) {
                          console.log('response email', response.email)
                          self.showLoader();
                          if (!self.checkCookie()) {
                            EventBus.$emit("loginUser", self.social, "L");
                          } else {
                            window.location.reload();
                          }
                        } else {
                          self.emailPopup = true;
                          self.width = "25%";
                          self.showLoginForm = false;
                          //
                          self.mode = "FACEBOOK";
                        }
                      }
                    })
                    .catch(error => {
                      self.emailPopup = false;
                      self.width = "25%";
                      self.showLoginForm = false;
                      //
                      self.mode = "FACEBOOK";
                    });
                }
              }
            );
          } else {
            // let GA = {
            //   "Event Label": "Failure",
            //   Status: "FAILURE",
            //   Response: JSON.stringify(response)
            // };
            // self.facebookLoginEvent(GA);
          }
        },
        { scope: 'public_profile,email'});
      // });
    },
    showResetPasswordPopup(state) {
      EventBus.$emit("ResetPasswordPopup", state);
    },
    openSignUpPopup() {
      // Hide the popup
      this.closePopupCB();
      // open Login Popup
      EventBus.$emit("SignPopup", this.previousActionData);
    },
    closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    showLoader() {
      this.showLoading = true;
      this.$refs.loginBtnSubmit.disabled = true;
      this.$refs.signupBtn.disabled = true;
    },
    loginUserCB() {
      if (!this.isFormValid()) return;
      // To disable:
      document.getElementById("googlelogin").style.pointerEvents = "none";
      //
      this.showLoader();
      //
      if (!this.checkCookie()) {
        EventBus.$emit(
          "loginUser",
          {
            email: this.userEmail,
            password: this.password,
            app: "SELF"
          },
          "L"
        );
      } else {
        window.location.reload();
      }
    },
    isFormValid() {
      return this.validateEmailInput() && this.validatePassword();
    },
    validateEmailInput() {
      let maxChar = 128;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter E-mail";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError =
          "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = `E-mail must be less than ${maxChar} characters`;
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    },
    validatePassword() {
      let minChar = 8;
      let maxChar = 16;

      if (!this.password) {
        this.passwordError = "Please enter Password";
        document.getElementById("password").classList.add("formError");
        return false;
      } else if (
        this.password.length < minChar ||
        this.password.length > maxChar
      ) {
        this.passwordError = `Password should be ${minChar} - ${maxChar} characters long`;
        document.getElementById("password").classList.add("formError");
        return false;
      }
      // else if (this.password.length > maxChar) {
      //   this.passwordError = `Password must be less than ${maxChar} characters`;
      //   document.getElementById("password").classList.add("formError");
      //   return false;
      // }
      // else if (!this.validateInputPassword(this.password)) {
      //   this.passwordError = `Password should contain atleast One special charcter, One upper case and One number.`;
      //   document.getElementById('password').classList.add('formError');
      //   return false;
      // }
      else {
        this.passwordError = "";
        document.getElementById("password").classList.remove("formError");
        return true;
      }
    },

    toggleInputMode(_event) {
      // Get the target element
      let target = _event.target;
      // Get the container div of the input field
      let parentNode = target.parentNode.parentNode;
      // Get the input element from it
      let inputElm = parentNode.getElementsByTagName("input")[0];
      // Now change the type to text if password or vice-versa and change the icon
      if (inputElm.type === "password") {
        inputElm.type = "text";
        // Change the icon
        target.src = this.iconEyeClosePath;
      } else {
        inputElm.type = "password";
        // Change the icon
        target.src = this.iconEyeOpenPath;
      }
    }
  },
  mixins: [Content, Utility, GoogleAnalytics]
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/variables";

input::-ms-clear,
input::-ms-reveal {
  display: none;
}
input:invalid {
  outline: none;
}

input[type="text"],
input[type="search"],
input[type="password"],
input[type="email"],
textarea {
  font-size: 18px;
  font-weight: 400;
}
input {
  caret-color: #4558dd;
  width: 2px;
}
.session-exp-popup {
  padding: 20px;
}
.login-logo {
  text-align: center;
  img {
    width: 25%;
    margin: 5% 0;
  }
}
.vlt-signup-divd {
  p {
    display: block;
    margin: 15px 0;
    color: $font-clr-black;
    font-weight: 550;
    font-size: 15px;
    text-align: center;
    font-family: "ProximanovaBold";
  }
  .orline {
    border-bottom: 1px solid #dcdcdc;
    margin-top: 5%;
  }
}
.social-logo {
  margin: 0 10% 0 10%;
  display: flex;
  // text-align: center;
  div {
    flex: 1;
    div {
      cursor: pointer;
      img {
        margin: 10px;
        width: 15%;
        float: left;
      }
      p {
        float: left;
        font-family: "ProximanovaBold";
        margin-left: 5px;
      }
    }
  }
}
.social-fb {
  div {
    background: #3b5998;
    border-radius: 2px;
    p {
      color: #ffffff;
      font-size: 18px;
      margin-top: 10px;
    }
  }
}
.social-google {
  div {
    border: 2px solid rgb(239, 236, 236);
    border-radius: 2px;
    background: rgb(239, 236, 236);
    p {
      color: #000000;
      font-size: 18px;
      margin-top: 8px;
    }
  }
}
.login-form {
  margin: 0 10% 0 10%;
}
.vlt-input-group {
  margin: 0 0 10px 0;
}
.vlt-lgn-fgtpwd {
  color: #212121;
  font-family: "ProximanovaBold";
  margin-bottom: 15px;
  &:hover {
    text-decoration: underline;
  }
}
.vlt-signup {
  padding: 20px;

  :nth-child(1) {
    margin-left: 15%;
  }
  :nth-child(2) {
    margin-left: 10px;
    cursor: pointer;
    font-weight: 600;
  }
  p {
    color: $font-clr-black;
    float: left;
  }
}
.login-header {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 30px;
  // line-height: 37px;
}
.login-with {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 14px;
  text-align: justify;
  margin: 2% 0;
}
.or {
  color: #212121;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  text-align: justify;
}
.login-label {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 16px;
  line-height: 20px;
}
.login-error-message {
  color: #d0021b;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  font-weight: 100;
  line-height: 18px;
  margin-top: 5px;
}
.new-user {
  color: #212121;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  line-height: 18px;
}
.signup {
  color: #4558dd !important;
  font-family: "ProximanovaBold";
  font-size: 16px;
  line-height: 18px;
  font-weight: bold;
  border: none;
  background: transparent;
  &:hover {
    text-decoration: underline;
  }
}
.check-container {
  margin: 5%;
  p {
    &:first-child {
      text-align: center;
      font-size: 15px;
      margin-bottom: 10px;
      color: #212121;
      font-family: "ProximanovaSemibold";
    }
  }
  button {
    &:nth-child(1) {
      margin-bottom: 20px;
    }
    &.no {
      color: #212121 !important;
      background: #ffffff !important;
      border: 1px solid #212121 !important;
      &:hover {
        background: #212121 !important;
        color: #ffffff !important;
      }
    }
  }
}
.agecheck {
  color: #212121;
  font-family: "ProximanovaSemibold";
  font-size: 18px;
  line-height: 30px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .session-exp-popup {
    padding: 10px;
  }
  .vlt-input-group {
    margin: 0 0 5px 0;
    label {
      font-size: 14px;
    }
  }
  .login-header {
    font-size: 20px;
  }
  .vlt-signup-divd {
    p {
      margin: 7px 0;
      font-size: 16px;
    }
  }
  input[type="email"],
  input[type="password"],
  input[type="text"] {
    height: 30px;
  }
  .vlt-lgn-fgtpwd {
    margin-bottom: 8px;
    font-size: 12px;
  }
  button {
    padding: 8px;
    font-size: 15px;
  }
  .vlt-signup {
    padding: 10px;
    text-align: center;

    :nth-child(1) {
      margin-left: 0%;
    }
    :nth-child(2) {
      margin-left: 0%;
    }
    p {
      display: inline;
      text-align: center;
      float: none;
    }
  }
  .social-fb {
    div {
      p {
        font-size: 14px;
      }
    }
  }
  .social-google {
    div {
      p {
        font-size: 14px;
      }
    }
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/Login.vue